(() => {
  const run = () => {
    const productSection = document.querySelector('[data-rsvp-product-layout]');
    if (!productSection) return;

    const productImages = Array.from(
      productSection.querySelectorAll('.rsvp-product-media-grid__image')
    );

    productImages.forEach((image, index) => {
      image.decoding = 'async';

      if (index === 0) {
        image.loading = 'eager';
        image.fetchPriority = 'high';
      } else {
        image.loading = 'lazy';
        image.fetchPriority = 'low';
      }
    });

    const productVideos = Array.from(
      productSection.querySelectorAll('.rsvp-product-media-grid__video')
    );

    productVideos.forEach((video) => {
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.preload = 'none';
      video.pause();
    });

    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;

            if (entry.isIntersecting) {
              video.preload = 'metadata';
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            } else {
              video.pause();
            }
          });
        },
        {
          rootMargin: '200px 0px',
          threshold: 0.1,
        }
      );

      productVideos.forEach((video) => videoObserver.observe(video));
    }

    const storyVideos = Array.from(
      productSection.querySelectorAll('.rsvp-product-video-stories video')
    );

    storyVideos.forEach((video) => {
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.preload = 'none';
      video.pause();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
